import React from 'react';
import classes from '../InviteFriend.module.scss';

export default <div className={classes.infoContainer}>
  <h1>
    Get <mark>50 FREESPIN</mark> in the Amount of 10 GEL as a Gift in the Slot Game -{' '}
    <mark>20 Burning Hot</mark>
    <br />
    <span style={{ display: 'block', marginTop: '1rem' }}>
        Per Each Invited and Verified Friend
      </span>
  </h1>
  <section>
    <h2>Registration</h2>
    <p>1. After logging in, press the Invite button in your account.</p>
    <p>
      2. Enter the mobile number and personal number of the person you would like to invite and press the Continue button.
    </p>
    <p>
      3. SMS code will be sent to the indicated number. Enter the code into the relevant field and press the Confirm button.
    </p>
    <p>
      4. After verification of the number, enter Email and Username of a friend, read and mark the necessary field and press the Complete button.
    </p>
  </section>
  <section>
    <h2>Verification</h2>
    <p>
      5. Once the registration process is complete, wait for a friend to upload the documents and go through the verification, or if you wish to verify your friend by yourself, press the Upload Documents button.
    </p>
    <p>
      6. Select ID card or Passport, upload both sides of your friend’s document, his selfie and press the Upload Documents button.
    </p>
    <p>
      7. The documents are uploaded for the verification. You can watch your friend’s status in the list.
    </p>
  </section>
  <section>
    <h2>How can I check my friend’s status?</h2>
    <p>
      The stage of verification process is displayed in the list of the invited friends, in the status field:
    </p>
    <p>
      Verification – The verification process has not started yet. The upload process of the documents and their verification starts by clicking the button.
    </p>
    <p>
      Pending – The documents are uploaded and information is processing.
    </p>
    <p>
      Update – Verification process failed and the damaged document must be uploaded again.
    </p>
    <p>
      Rejected – The information is verified and the verification process of the user was completed unsuccessfully.
    </p>
    <p>
      Completed – If the field is marked in green it means that the verification process was completed successfully and the prize - <mark>50 FREESPIN</mark> will be activated for you soon.
    </p>
    <br />
    <p>
      Activate additional prizes in the Slot Game - <mark>20 Burning Hot</mark> once you register 10, 30 and 50 users:
    </p>
    <ul>
      <li>
        10 Friends: <mark>+100 FREESPIN</mark>
      </li>
      <li>
        30 Friends: <mark>+300 FREESPIN</mark>
      </li>
      <li>
        50 Friends: <mark>+500 FREESPIN</mark>
      </li>
    </ul>
    <p>
      You will get your prizes within 30 minutes upon completion of verification.
    </p>
  </section>
</div>